import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SpinnerLoader from '../../../layout/components/helpers/SpinnerLoader';
import NoInfo from '../../../layout/components/helpers/NoInfo';
import colors from '../../../constants/colors';
import ModulePermission from '../../../layout/components/helpers/ModulePermission';
import { axiosPath } from '../../../routing/helpers/router';
import { useDispatch, useSelector } from 'react-redux';
import * as currentPageAction from '@/store/actions/currentPageAction';
import Intelligence from '@/layout/screenSpecifics/Modules/Intelligence/Intelligence';

const IntelligenceHomeScreen = () => {
  const { moduleBridgeHex } = useParams();
  ModulePermission(moduleBridgeHex);

  const module = useSelector((state) => state.currentPage?.module);
  const dispatch = useDispatch();

  const [newReports] = useState([
    1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 23, 24,
    25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 40, 41, 42, 43, 44, 47, 49, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61,
  ]);

  // > LOAD MODULE
  const loadModule = useCallback(async () => {
    await axios
      .post(axiosPath('api_r_user_module_intelligence_home'), {
        moduleBridgeHex,
      })
      .then(({ data }) => {
        dispatch(currentPageAction.change('module', data, true));
        dispatch(
          currentPageAction.change(
            'intelligenceProfiles',
            data.intelligenceProfiles,
            true,
          ),
        );
        dispatch(currentPageAction.change('newReports', newReports, true));
      });
  }, []);

  useEffect(() => {
    loadModule();
  }, []);
  // < LOAD MODULE

  return (
    <div className="relative m_sr pl-2 pr-2">
      {module ? (
        <>
          <Intelligence />
        </>
      ) : (
        <div style={{ marginTop: '200px' }}>
          <NoInfo icon={<SpinnerLoader />} text="" color={colors.primary} />
        </div>
      )}
    </div>
  );
};

export default IntelligenceHomeScreen;
